import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';

export class FlowKeyboardController
{
    public static KEY_MAP = {
        '_esc': ['esc']
    };

    public static readonly KEY_HANDLERS = {};

    public init():void
    {
        this._initKeyHandlersMap();
    }

    public getKeyMap():any
    {
        return FlowKeyboardController.KEY_MAP;
    }

    public getKeyHandlers():any
    {
        return FlowKeyboardController.KEY_HANDLERS;
    }

    private _initKeyHandlersMap()
    {
        const keyHandlers = FlowKeyboardController.KEY_HANDLERS;
        const keyMap = FlowKeyboardController.KEY_MAP;

        for( const funcName in keyMap )
        {
            const keyHandler = this[funcName];

            if( !keyHandler )
                console.error(`Could not find keyboard handler for ${funcName}`);

            keyHandlers[funcName] = keyHandler;
        }
    }

    private _esc = () =>
    {
        controllers.ui.flowTopBar.setWonderBarVisibility(false);
    };
}
